import React from 'react';

export default function template(props) {
  const {title, items} = props;

  return (
    <div className="calculator-new__estimation estimation-calculator-new">
      <h3 className="estimation-calculator-new__title">{title}</h3>
      <div className="estimation-calculator-new__body">
        {items
          .filter(item => item.value !== null)
          .map(item => (
            <div className="estimation-calculator-new__row" key={item.label}>
              <div className="estimation-calculator-new__label">{item.label}</div>
              <div className="estimation-calculator-new__value">{item.value}</div>
            </div>
          ))}
      </div>
    </div>
  );
}
